import { render, staticRenderFns } from "./VacancyDescription.vue?vue&type=template&id=f4abc284"
import script from "./VacancyDescription.vue?vue&type=script&lang=js"
export * from "./VacancyDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports